import { atom } from 'recoil';

export interface MediaGalleryItem {
    url: string;
}

export interface MediaGalleryState {
    medias: MediaGalleryItem[];
    initialIndex: number;
}

export const mediaGalleryDefaultState: MediaGalleryState = {
    medias: [],
    initialIndex: 0,
};

/**
 * State for the media gallery.
 */
export const mediaGalleryAtom = atom<{
    medias: MediaGalleryItem[];
    initialIndex: number;
}>({
    key: 'mediaGalleryState',
    default: mediaGalleryDefaultState,
});
